/**
 * 무기 종류 표 — **자동 생성 파일. 직접 고치지 말 것.**
 *
 * 서버는 인벤토리 아이템의 표시명으로 `$3283` 같은 원본 클라이언트 리소스
 * 키만 보낸다. 그것이 활인지 검인지는 패킷에 없지만 클라이언트는 알아야
 * 한다 — 손에 든 무기에 따라 캐릭터 그림이 달라지고, 공격 모션도 근접과
 * 원거리로 갈리기 때문이다.
 *
 * 값은 스프라이트 무기 종류(none/sword/bow/staff)다. 원본 그림이 네 갈래
 * 뿐이라 창·둔기 같은 근접 무기는 모두 검 그림으로 접어 넣는다.
 *
 * 재생성: python3 scripts/gen_weapon_types.py > web-client/src/data/weaponTypes.ts
 */
import type { WeaponType } from '../utils/spriteLoader';

export const WEAPON_TYPES: Record<string, WeaponType> = {
  '$1958 $1938': 'sword',
  '$1958 $1939': 'sword',
  '$0': 'sword',
  '$2458 $2449': 'sword',
  '$2459 $2449': 'sword',
  '$2460 $2449': 'sword',
  '$656 $2449': 'sword',
  '$2452 $2449': 'sword',
  '$2461 $2449': 'sword',
  '$2462 $2449': 'sword',
  '$2453 $2449': 'sword',
  '$2458 $372': 'sword',
  '$2459 $372': 'sword',
  '$2460 $372': 'sword',
  '$656 $372': 'sword',
  '$2452 $372': 'sword',
  '$2461 $372': 'sword',
  '$2462 $372': 'sword',
  '$2453 $372': 'sword',
  '$1958 $1940': 'bow',
  '$2452 $784': 'bow',
  '$2453 $784': 'bow',
  '$10236$2449': 'sword',
  '$10236$2450': 'sword',
  '$1': 'sword',
  '$3': 'sword',
  '$12': 'sword',
  '$13': 'sword',
  '$14': 'sword',
  '$16': 'sword',
  '$17': 'sword',
  '$20': 'sword',
  '$24': 'bow',
  '$25': 'sword',
  '$60': 'sword',
  '$62': 'sword',
  '$63': 'sword',
  '$64': 'bow',
  '$65': 'bow',
  '$66': 'sword',
  '$69': 'sword',
  '$70': 'sword',
  '$71': 'sword',
  '$73': 'sword',
  '$74': 'sword',
  '$75': 'sword',
  '$76': 'sword',
  '$77': 'sword',
  '$81': 'sword',
  '$83': 'sword',
  '$84': 'sword',
  '$87': 'sword',
  '$92': 'sword',
  '$94': 'sword',
  '$95': 'sword',
  '$96': 'sword',
  '$97': 'sword',
  '$98': 'sword',
  '$99': 'sword',
  '$100': 'sword',
  '$102': 'sword',
  '$103': 'sword',
  '$105': 'bow',
  '$111': 'sword',
  '$313': 'sword',
  '$412': 'sword',
  '$415': 'sword',
  '$416': 'sword',
  '$417': 'sword',
  '$418': 'sword',
  '$428': 'sword',
  '$570': 'staff',
  '$571': 'staff',
  '$572': 'staff',
  '$573': 'staff',
  '$598': 'sword',
  '$759': 'bow',
  '$783': 'sword',
  '$784': 'bow',
  '$785': 'sword',
  '$786': 'sword',
  '$787': 'sword',
  '$789': 'sword',
  '$791': 'sword',
  '$792': 'sword',
  '$793': 'sword',
  '$801': 'sword',
  '$802': 'sword',
  '$803': 'sword',
  '$1020': 'sword',
  '$1048': 'sword',
  '$1063': 'staff',
  '$1098': 'sword',
  '$1099': 'bow',
  '$1147': 'sword',
  '$1148': 'sword',
  '$1149': 'sword',
  '$1244': 'bow',
  '$1553': 'sword',
  '$1762': 'sword',
  '$1766': 'bow',
  '$1770': 'staff',
  '$1821': 'bow',
  '$1950': 'sword',
  '$1951': 'sword',
  '$1952': 'bow',
  '$1997': 'sword',
  '$1999': 'bow',
  '$2003': 'staff',
  '$2079': 'staff',
  '$2080': 'staff',
  '$2208': 'sword',
  '$2214': 'sword',
  '$2241': 'staff',
  '$2252': 'bow',
  '$2253': 'sword',
  '$2293': 'sword',
  '$2350': 'sword',
  '$2352': 'bow',
  '$2353': 'sword',
  '$2354': 'sword',
  '$2455': 'sword',
  '$2456': 'sword',
  '$2457': 'bow',
  '$2464': 'sword',
  '$2536': 'sword',
  '$2626': 'sword',
  '$2648': 'sword',
  '$2754': 'staff',
  '$2758': 'sword',
  '$2759': 'sword',
  '$2760': 'sword',
  '$2761': 'sword',
  '$2762': 'sword',
  '$2763': 'sword',
  '$2764': 'staff',
  '$2766': 'staff',
  '$2768': 'staff',
  '$2771': 'bow',
  '$2772': 'sword',
  '$2777': 'sword',
  '$2859': 'sword',
  '$2903': 'sword',
  '$2904': 'sword',
  '$2905': 'sword',
  '$2906': 'sword',
  '$2907': 'bow',
  '$2908': 'bow',
  '$2909': 'staff',
  '$2915': 'bow',
  '$2920': 'sword',
  '$2990': 'staff',
  '$2991': 'staff',
  '$2992': 'staff',
  '$2993': 'staff',
  '$3073': 'sword',
  '$3078': 'staff',
  '$3089': 'staff',
  '$3110': 'sword',
  '$3111': 'sword',
  '$3112': 'bow',
  '$3247': 'sword',
  '$3248': 'sword',
  '$3249': 'sword',
  '$3250': 'sword',
  '$3279': 'sword',
  '$3280': 'sword',
  '$3281': 'sword',
  '$3282': 'sword',
  '$3283': 'bow',
  '$3284': 'bow',
  '$3285': 'staff',
  '$3286': 'sword',
  '$3287': 'sword',
  '$3288': 'sword',
  '$3374': 'bow',
  '$3375': 'sword',
  '$3376': 'sword',
  '$3377': 'sword',
  '$3504': 'sword',
  '$3505': 'sword',
  '$3612': 'sword',
  '$3735': 'sword',
  '$3736': 'bow',
  '$3737': 'sword',
  '$3790': 'sword',
  '$3791': 'sword',
  '$3792': 'bow',
  '$3793': 'staff',
  '$3795': 'sword',
  '$3796': 'sword',
  '$3834': 'sword',
  '$3835': 'sword',
  '$3836': 'sword',
  '$3837': 'sword',
  '$3838': 'staff',
  '$3839': 'sword',
  '$3840': 'sword',
  '$3847': 'staff',
  '$3860': 'sword',
  '$3861': 'sword',
  '$3863': 'sword',
  '$3864': 'sword',
  '$3865': 'staff',
  '$3866': 'sword',
  '$3867': 'sword',
  '$3997': 'bow',
  '$4046': 'sword',
  '$4338': 'sword',
  '$4350': 'bow',
  '$4375': 'sword',
  '$4376': 'staff',
  '$4384': 'sword',
  '$4385': 'sword',
  '$4386': 'sword',
  '$4387': 'bow',
  '$4423': 'sword',
  '$4429': 'sword',
  '$4442': 'sword',
  '$4962': 'sword',
  '$5117': 'sword',
  '$5118': 'sword',
  '$5119': 'sword',
  '$5120': 'bow',
  '$5121': 'sword',
  '$5122': 'sword',
  '$5123': 'sword',
  '$5124': 'sword',
  '$5125': 'staff',
  '$5126': 'sword',
  '$5254': 'sword',
  '$5486': 'sword',
  '$5487': 'sword',
  '$5488': 'sword',
  '$5490': 'sword',
  '$5491': 'sword',
  '$5631': 'staff',
  '$5661': 'staff',
  '$5662': 'sword',
  '$5663': 'sword',
  '$5664': 'sword',
  '$5668': 'sword',
  '$5669': 'sword',
  '$5718': 'sword',
  '$5719': 'sword',
  '$5720': 'bow',
  '$5721': 'staff',
  '$5828': 'sword',
  '$5829': 'sword',
  '$5830': 'sword',
  '$5831': 'bow',
  '$5832': 'sword',
  '$5833': 'staff',
  '$6405': 'sword',
  '$6406': 'sword',
  '$6428': 'sword',
  '$6429': 'sword',
  '$7936': 'sword',
  '$7937': 'bow',
  '$7938': 'staff',
  '$7939': 'sword',
  '$7940': 'sword',
  '$7941': 'sword',
  '$8824': 'sword',
  '$8825': 'bow',
  '$8826': 'staff',
  '$8827': 'sword',
  '$8828': 'sword',
  '$8829': 'sword',
  '$9048': 'bow',
  '$9064': 'sword',
  '$9066': 'sword',
  '$10738': 'sword',
  '$10739': 'staff',
  '$10740': 'sword',
  '$10741': 'sword',
  '$10742': 'sword',
  '$10743': 'bow',
  '$12562': 'sword',
  '$12563': 'sword',
  '$12564': 'bow',
  '$12565': 'staff',
  '$12566': 'sword',
  '$12901': 'sword',
  '$12902': 'sword',
  '$13780': 'bow',
  '$13819': 'staff',
  '$14384': 'sword',
};
